import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../../services/apis";
import { Icon, Pagination } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  ContainerPaginate,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";

import Back from "../../../../../components/Admin/Pocketbook/parceiros/Criar/Back";

const ListagemParceirosPocket = (props) => {
  const [parceirosPocket, setParceirosPocket] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [pages, setPages] = useState(0);

  useEffect(() => {
    loadParceiros();
  }, [currentPage]);

  const loadParceiros = useCallback(async () => {
    try {
      const params = {
        page: currentPage,
      };

      if (search) {
        params.search = search;
      }

      const response = await api.get("/pb4y-listagem-solicitacoes-parceiros", {
        params,
      });
      const { parceirosPocket, count } = response.data;

      let array = {
        local: "parceirosPocket",
        texto: `listou os parceiros do pocket`,
      };
      await api.post("system_logs", { acao: JSON.stringify(array) });

      setParceirosPocket(parceirosPocket);
      setPages(count);
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar os parceiros", "", "").then((res) =>
        props.history.push("/")
      );
    }
  }, [currentPage, search]);

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back />
          <Title>Listagem de parceiros do pocket</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Procurar Parceiro"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Icon name="search icon" />

            <CreateButton onClick={loadParceiros}>Procurar</CreateButton>
          </ContainerInputSearch>

          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>
                  Nome do parceiro
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>E-mail</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Whatsapp</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>instagram</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>blog</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Tipo de parceria
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Descrição</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Localização</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Formação</SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              {parceirosPocket?.map((parceiro, index) => (
                <SemanticTable.Row key={index}>
                  <SemanticTable.Cell>{parceiro.nome}</SemanticTable.Cell>
                  <SemanticTable.Cell>{parceiro.email}</SemanticTable.Cell>
                  <SemanticTable.Cell>{parceiro.telefone}</SemanticTable.Cell>
                  <SemanticTable.Cell>{parceiro.instagram}</SemanticTable.Cell>
                  <SemanticTable.Cell>{parceiro.blog}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {parceiro.tipo === 2 ? "Influenciador" : "Blog"}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {parceiro.description}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {parceiro.localizacao}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>{parceiro.formacao}</SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
            </SemanticTable.Body>
          </SemanticTable>
          <ContainerPaginate>
            <Pagination
              defaultActivePage={1}
              ellipsisItem={null}
              // siblingRange={1}
              totalPages={pages}
              onPageChange={(e, f) => setCurrentPage(f.activePage)}
              page={currentPage}
            />
          </ContainerPaginate>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(ListagemParceirosPocket);
